import * as React from "react";
const SvgPrimaryUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={31}
    fill="none"
    {...props}
  >
    <path
      stroke="url(#primaryUser_svg__a)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M10.682 13.564a2.6 2.6 0 0 0-.463 0A6.2 6.2 0 0 1 4.231 7.35a6.22 6.22 0 0 1 6.227-6.226 6.23 6.23 0 0 1 6.226 6.226c-.014 3.366-2.665 6.1-6.002 6.213"
    />
    <path
      stroke="url(#primaryUser_svg__b)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M3.67 18.738c-3.393 2.272-3.393 5.974 0 8.232 3.857 2.58 10.181 2.58 14.037 0 3.394-2.272 3.394-5.974 0-8.232-3.842-2.566-10.166-2.566-14.037 0"
    />
    <defs>
      <linearGradient
        id="primaryUser_svg__a"
        x1={20.253}
        x2={1.125}
        y1={15.015}
        y2={15.015}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#082B60" />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="primaryUser_svg__b"
        x1={20.253}
        x2={1.125}
        y1={15.015}
        y2={15.015}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#082B60" />
        <stop offset={1} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgPrimaryUser;
